import React from 'react'

import { IconButton } from 'component-library/buttons/IconButton/IconButton'
import { colors } from 'component-library/__styling/settings'

import { IconReddit } from 'component-library/icons/IconReddit/IconReddit'
import { IconInstagram } from 'component-library/icons/IconInstagram/IconInstagram'
import { IconFacebook } from 'component-library/icons/IconFacebook/IconFacebook'
import { IconTwitter } from 'component-library/icons/IconTwitter/IconTwitter'
import { IconEmail } from 'component-library/icons/IconEmail/IconEmail'
import { IconLink } from 'component-library/icons/IconLink/IconLink'
import { IconRSS } from 'component-library/icons/IconRSS/IconRSS'
import { IconYoutube } from 'component-library/icons/IconYoutube/IconYoutube'

interface Props {
    title?: string
    link: string
    className?: string
    iconScale?: number
    baseColor?: string
}

export const FacebookIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.facebook}
        icon={<IconFacebook title={props.title} />}
        iconScale={0.75}
        noBorder={true}
        offset={{ top: 65, left: 50 }}
        {...props}
    />
)

export const TwitterIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.twitter}
        icon={<IconTwitter title={props.title} />}
        iconScale={0.62}
        {...props}
    />
)

export const InstagramIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.instagram}
        icon={<IconInstagram title={props.title} />}
        iconScale={0.63}
        {...props}
    />
)

export const YoutubeIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.youtube}
        icon={<IconYoutube title={props.title} />}
        iconScale={0.63}
        {...props}
    />
)

export const RSSIconButton: React.FC<Props> = props => (
    <IconButton
        useAnchorTag={true}
        baseColor={colors.social.rss}
        icon={<IconRSS title={props.title} />}
        iconScale={0.6}
        {...props}
    />
)

export const RedditIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.reddit}
        icon={<IconReddit title={props.title} />}
        {...props}
    />
)

export const LinkIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.clipboard}
        icon={<IconLink title={props.title} />}
        iconScale={0.6}
        {...props}
    />
)

export const EmailIconButton: React.FC<Props> = props => (
    <IconButton
        baseColor={colors.social.email}
        icon={<IconEmail title={props.title} />}
        iconScale={0.61}
        {...props}
    />
)
